import React from 'react';

import type { CtaData } from '../../../../types/blog';

interface Props {
  data: CtaData;
  onChange: (data: CtaData) => void;
}

const inputCls = 'ds-input ds-input-sm';

const LabeledInput: React.FC<React.InputHTMLAttributes<HTMLInputElement> & { label: string }> = ({
  label, ...props
}) => (
  <div className="flex flex-col gap-1">
    <label className="t-label">{label}</label>
    <input {...props} className={inputCls} />
  </div>
);

export const CtaSectionEditor: React.FC<Props> = ({ data, onChange }) => (
  <div className="flex flex-col gap-3">
    <LabeledInput
      label="Headline *"
      value={data.headline}
      onChange={(e) => onChange({ ...data, headline: e.target.value })}
      placeholder="Ready to find your next job?"
    />
    <div className="flex flex-col gap-1">
      <label className="t-label">Description</label>
      <textarea
        value={data.description ?? ''}
        onChange={(e) => onChange({ ...data, description: e.target.value })}
        rows={2}
        placeholder="Supporting text below the headline…"
        className="ds-textarea resize-none"
      />
    </div>
    <div className="grid grid-cols-2 gap-3">
      <LabeledInput
        label="Button text"
        value={data.button_text ?? ''}
        onChange={(e) => onChange({ ...data, button_text: e.target.value })}
        placeholder="Get started free"
      />
      <LabeledInput
        label="Button link"
        value={data.button_link ?? ''}
        onChange={(e) => onChange({ ...data, button_link: e.target.value })}
        placeholder="https://gograbjob.com/signup"
      />
    </div>
    {data.headline && (
      <div className="mt-1 ds-card-sm">
        <p className="t-card-title">{data.headline}</p>
        {data.description && <p className="t-meta mt-0.5">{data.description}</p>}
        {data.button_text && (
          <span className="mt-2 ds-chip ds-chip-brand">
            {data.button_text}
          </span>
        )}
      </div>
    )}
  </div>
);
